import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./header.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutAction } from "../../store/actions/auth.action";
import { ERoutes } from "../../enums/routes";
import { getBulkPermission } from "../../api/endpoints/search";
import { authSelector } from "../../store/selectors/index";
import { useSelector } from "react-redux";
import { getSiteRefrence } from "../../api/endpoints/refrences";


const SideBar = () => {
  const { access_token } = useSelector(authSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const [siteName, setSiteName] = useState();
  const [open, setOpen] = useState(true);
  const [state, setState] = useState({
    bulkSale: "",
    bulkPurchase: "",
    petty: "",
  });

  const getRefrences = async () => {
    const _refrences = await getSiteRefrence(access_token);
          setSiteName(_refrences.data.siteName);
  };

  const getAllData = async () => {
    const _bulkPermission = await getBulkPermission(access_token);
    setState({
      ...state,
      bulkSale: _bulkPermission.bulkSale,
      bulkPurchase: _bulkPermission.bulkPurchase,
      petty: _bulkPermission.petty,
    });
  };
  useEffect(() => {
    getAllData();
    getRefrences()
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    dispatch(logoutAction());
    navigate("/");
  };
  return (
    <>
    <div>
        <div className="w-full bg-blue-500 py-2">
  <marquee behavior="scroll" direction="left" scrollamount="6">
    <span style={{ color: "white", fontSize: "22px", fontWeight: "bold", letterSpacing: "1px" }}>
      {siteName}
    </span>
  </marquee>
</div>
    <div
      className={` ${
        open ? "w-64" : "w-20 "
      }  h-screen p-5 navClass  pt-8  relative duration-300  `}
    >
    
      <img
        src="./assets/control.png"
        alt=""
        className={`absolute arrow cursor-pointer -right-3 top-9 w-7 
       border-2 rounded-full  ${!open && "rotate-180"}`}
        onClick={() => setOpen(!open)}
      />
      <Link to="/mainScreen">
        <div className="flex gap-x-4 items-center">
          <img
            src="./assets/logo.png"
            alt=""
            className={`cursor-pointer duration-500 ${
              open && "rotate-[360deg]"
            }`}
          />
          <h1
            className={`text-white origin-left logoHeading font-medium text-xl duration-200 ${
              !open && "scale-0"
            }`}
          >
            IT WORLD
            {/* IT W<span class="braces">&#123;&#125;</span>RLD */}
          </h1>
        </div>
      </Link>
      
      <ul className="pt-4">
        <Link to="/meter">
          <li
            className={`flex ${
              pathname === ERoutes.METER ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Meters.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              METERS
            </span>
          </li>
        </Link>
        <Link to="/lubeSale">
          <li
            className={`flex ${
              pathname === ERoutes.LUBE_SALE ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Lubes.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              LUBES
            </span>
          </li>
        </Link>
        <Link to="/dip">
          <li
            className={`flex ${
              pathname === ERoutes.DIP ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/fuel.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              DIPS
            </span>
          </li>
        </Link>
        <Link to="/purchase">
          <li
            className={`flex ${
              pathname === ERoutes.PURCHASE ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Purchase.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              PURCHASE
            </span>
          </li>
        </Link>

        <Link to="/credits">
          <li
            className={`flex ${
              pathname === ERoutes.CREDITS ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/creditCard.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              CREDITS
            </span>
          </li>
        </Link>
        <Link to="/cards">
          <li
            className={`flex ${
              pathname === ERoutes.CARDS ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Cards.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              CARDS
            </span>
          </li>
        </Link>
        <Link to="/receipts">
          <li
            className={`flex ${
              pathname === ERoutes.RECEIPT ? "bg-blue-500" : ""
            }  rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Receipt.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              RECEIPT
            </span>
          </li>
        </Link>
        <Link to="/payment">
          <li
            className={`flex ${
              pathname === ERoutes.PAYMENT ? "bg-blue-500" : ""
            }  rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Payment.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              PAYMENT
            </span>
          </li>
        </Link>

        {state.petty === false && (
          <Link to="/expenseVoucher">
            <li
              className={`flex ${
                pathname === ERoutes.EXPENSE ? "bg-blue-500" : ""
              } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
            >
              <img src={`./assets/Cash.png`} alt="" />
              <span className={`${!open && "hidden"} origin-left duration-200`}>
                Expense
              </span>
            </li>
          </Link>
        )}
        {state.petty === true && (
          <Link to="/pettyExpenseVoucher">
            <li
              className={`flex ${
                pathname === ERoutes.PETTY_EXPENSE ? "bg-blue-500" : ""
              } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
               mb-1`}
            >
              <img src={`./assets/Cash.png`} alt="" />
              <span className={`${!open && "hidden"} origin-left duration-200`}>
                Petty Expense
              </span>
            </li>
          </Link>
        )}

        <Link to="/bankVoucher">
          <li
            className={`flex ${
              pathname === ERoutes.BANK ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/bank.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              Bank
            </span>
          </li>
        </Link>
        <Link to="/journalVoucher">
          <li
            className={`flex ${
              pathname === ERoutes.JV ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Ticket.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              JV
            </span>
          </li>
        </Link>
        {state.bulkSale === true && (
          <Link to="/bulkSale">
            <li
              className={`flex ${
                pathname === ERoutes.BULK_SALE ? "bg-blue-500" : ""
              } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
           mb-1`}
            >
              <img src={`./assets/fuel.png`} alt="" />

              <span className={`${!open && "hidden"} origin-left duration-200`}>
                BULK SALE
              </span>
            </li>
          </Link>
        )}
        {state.bulkPurchase === true && (
          <Link to="/bulkPurchase">
            <li
              className={`flex ${
                pathname === ERoutes.BULK_PURCHASE ? "bg-blue-500" : ""
              } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
           mb-1`}
            >
              <img src={`./assets/Ticket.png`} alt="" />
              <span className={`${!open && "hidden"} origin-left duration-200`}>
                BULK PURCHASE
              </span>
            </li>
          </Link>
        )}
        <Link to="/dailySheet">
          <li
            className={`flex  ${
              pathname === ERoutes.DAILYSHEET ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/DailySheet.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              DAILY SHEET
            </span>
          </li>
        </Link>
        <Link to="/createVehical">
          <li
            className={`flex ${
              pathname === ERoutes.VEHICAL ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Cards.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              Reg. Vehical
            </span>
          </li>
        </Link>
        {/* <Link to="/dayBook">
          <li
            className={`flex  ${
              pathname === ERoutes.DAILYSHEET ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/DailySheet.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              DAY BOOK
            </span>
          </li>
        </Link> */}
      </ul>
      <li
        onClick={logout}
        className={`flex  rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 `}
      >
        <img src={`./assets/Logout.png`} alt="" />
        <span className={`${!open && "hidden"} origin-left duration-200`}>
          Logout
        </span>
      </li>
    </div>
    </div>

    </>
  );
  // return (

  //   <div
  //     className={` ${
  //       open ? "w-64" : "w-20 "
  //     }  h-screen p-5 navClass  pt-8  relative duration-300  `}
  //   >
  //     <img
  //       src="./assets/control.png"
  //       alt=""
  //       className={`absolute arrow cursor-pointer -right-3 top-9 w-7 
  //      border-2 rounded-full  ${!open && "rotate-180"}`}
  //       onClick={() => setOpen(!open)}
  //     />
  //     <Link to="/mainScreen">
  //       <div className="flex gap-x-4 items-center">
  //         <img
  //           src="./assets/logo.png"
  //           alt=""
  //           className={`cursor-pointer duration-500 ${
  //             open && "rotate-[360deg]"
  //           }`}
  //         />
  //         <h1
  //           className={`text-white origin-left logoHeading font-medium text-xl duration-200 ${
  //             !open && "scale-0"
  //           }`}
  //         >
  //           IT WORLD
  //           {/* IT W<span class="braces">&#123;&#125;</span>RLD */}
  //         </h1>
  //       </div>
  //     </Link>
  //     <ul className="pt-4">
  //       <Link to="/meter">
  //         <li
  //           className={`flex ${
  //             pathname === ERoutes.METER ? "bg-blue-500" : ""
  //           } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //         >
  //           <img src={`./assets/Meters.png`} alt="" />
  //           <span className={`${!open && "hidden"} origin-left duration-200`}>
  //             METERS
  //           </span>
  //         </li>
  //       </Link>
  //       <Link to="/lubeSale">
  //         <li
  //           className={`flex ${
  //             pathname === ERoutes.LUBE_SALE ? "bg-blue-500" : ""
  //           } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //         >
  //           <img src={`./assets/Lubes.png`} alt="" />
  //           <span className={`${!open && "hidden"} origin-left duration-200`}>
  //             LUBES
  //           </span>
  //         </li>
  //       </Link>
  //       <Link to="/dip">
  //         <li
  //           className={`flex ${
  //             pathname === ERoutes.DIP ? "bg-blue-500" : ""
  //           } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //         >
  //           <img src={`./assets/fuel.png`} alt="" />
  //           <span className={`${!open && "hidden"} origin-left duration-200`}>
  //             DIPS
  //           </span>
  //         </li>
  //       </Link>
  //       <Link to="/purchase">
  //         <li
  //           className={`flex ${
  //             pathname === ERoutes.PURCHASE ? "bg-blue-500" : ""
  //           } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //         >
  //           <img src={`./assets/Purchase.png`} alt="" />
  //           <span className={`${!open && "hidden"} origin-left duration-200`}>
  //             PURCHASE
  //           </span>
  //         </li>
  //       </Link>

  //       <Link to="/credits">
  //         <li
  //           className={`flex ${
  //             pathname === ERoutes.CREDITS ? "bg-blue-500" : ""
  //           } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //         >
  //           <img src={`./assets/creditCard.png`} alt="" />
  //           <span className={`${!open && "hidden"} origin-left duration-200`}>
  //             CREDITS
  //           </span>
  //         </li>
  //       </Link>
  //       <Link to="/cards">
  //         <li
  //           className={`flex ${
  //             pathname === ERoutes.CARDS ? "bg-blue-500" : ""
  //           } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //         >
  //           <img src={`./assets/Cards.png`} alt="" />
  //           <span className={`${!open && "hidden"} origin-left duration-200`}>
  //             CARDS
  //           </span>
  //         </li>
  //       </Link>
  //       <Link to="/receipts">
  //         <li
  //           className={`flex ${
  //             pathname === ERoutes.RECEIPT ? "bg-blue-500" : ""
  //           }  rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //         >
  //           <img src={`./assets/Receipt.png`} alt="" />
  //           <span className={`${!open && "hidden"} origin-left duration-200`}>
  //             RECEIPT
  //           </span>
  //         </li>
  //       </Link>
  //       <Link to="/payment">
  //         <li
  //           className={`flex ${
  //             pathname === ERoutes.PAYMENT ? "bg-blue-500" : ""
  //           }  rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //         >
  //           <img src={`./assets/Payment.png`} alt="" />
  //           <span className={`${!open && "hidden"} origin-left duration-200`}>
  //             PAYMENT
  //           </span>
  //         </li>
  //       </Link>

  //       {state.petty === false && (
  //         <Link to="/expenseVoucher">
  //           <li
  //             className={`flex ${
  //               pathname === ERoutes.EXPENSE ? "bg-blue-500" : ""
  //             } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //           >
  //             <img src={`./assets/Cash.png`} alt="" />
  //             <span className={`${!open && "hidden"} origin-left duration-200`}>
  //               Expense
  //             </span>
  //           </li>
  //         </Link>
  //       )}
  //       {state.petty === true && (
  //         <Link to="/pettyExpenseVoucher">
  //           <li
  //             className={`flex ${
  //               pathname === ERoutes.PETTY_EXPENSE ? "bg-blue-500" : ""
  //             } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
  //              mb-1`}
  //           >
  //             <img src={`./assets/Cash.png`} alt="" />
  //             <span className={`${!open && "hidden"} origin-left duration-200`}>
  //               Petty Expense
  //             </span>
  //           </li>
  //         </Link>
  //       )}

  //       <Link to="/bankVoucher">
  //         <li
  //           className={`flex ${
  //             pathname === ERoutes.BANK ? "bg-blue-500" : ""
  //           } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //         >
  //           <img src={`./assets/bank.png`} alt="" />
  //           <span className={`${!open && "hidden"} origin-left duration-200`}>
  //             Bank
  //           </span>
  //         </li>
  //       </Link>
  //       <Link to="/journalVoucher">
  //         <li
  //           className={`flex ${
  //             pathname === ERoutes.JV ? "bg-blue-500" : ""
  //           } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //         >
  //           <img src={`./assets/Ticket.png`} alt="" />
  //           <span className={`${!open && "hidden"} origin-left duration-200`}>
  //             JV
  //           </span>
  //         </li>
  //       </Link>
  //       {state.bulkSale === true && (
  //         <Link to="/bulkSale">
  //           <li
  //             className={`flex ${
  //               pathname === ERoutes.BULK_SALE ? "bg-blue-500" : ""
  //             } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //           >
  //             <img src={`./assets/fuel.png`} alt="" />

  //             <span className={`${!open && "hidden"} origin-left duration-200`}>
  //               BULK SALE
  //             </span>
  //           </li>
  //         </Link>
  //       )}
  //       {state.bulkPurchase === true && (
  //         <Link to="/bulkPurchase">
  //           <li
  //             className={`flex ${
  //               pathname === ERoutes.BULK_PURCHASE ? "bg-blue-500" : ""
  //             } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //           >
  //             <img src={`./assets/Ticket.png`} alt="" />
  //             <span className={`${!open && "hidden"} origin-left duration-200`}>
  //               BULK PURCHASE
  //             </span>
  //           </li>
  //         </Link>
  //       )}
  //       <Link to="/dailySheet">
  //         <li
  //           className={`flex  ${
  //             pathname === ERoutes.DAILYSHEET ? "bg-blue-500" : ""
  //           } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //         >
  //           <img src={`./assets/DailySheet.png`} alt="" />
  //           <span className={`${!open && "hidden"} origin-left duration-200`}>
  //             DAILY SHEET
  //           </span>
  //         </li>
  //       </Link>
  //       <Link to="/createVehical">
  //         <li
  //           className={`flex ${
  //             pathname === ERoutes.VEHICAL ? "bg-blue-500" : ""
  //           } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //         >
  //           <img src={`./assets/Cards.png`} alt="" />
  //           <span className={`${!open && "hidden"} origin-left duration-200`}>
  //             Reg. Vehical
  //           </span>
  //         </li>
  //       </Link>
  //       {/* <Link to="/dayBook">
  //         <li
  //           className={`flex  ${
  //             pathname === ERoutes.DAILYSHEET ? "bg-blue-500" : ""
  //           } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
  //          mb-1`}
  //         >
  //           <img src={`./assets/DailySheet.png`} alt="" />
  //           <span className={`${!open && "hidden"} origin-left duration-200`}>
  //             DAY BOOK
  //           </span>
  //         </li>
  //       </Link> */}
  //     </ul>
  //     <li
  //       onClick={logout}
  //       className={`flex  rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 `}
  //     >
  //       <img src={`./assets/Logout.png`} alt="" />
  //       <span className={`${!open && "hidden"} origin-left duration-200`}>
  //         Logout
  //       </span>
  //     </li>
  //   </div>
  // );
};

export default SideBar;
